import { AutogenModelTariffRegionLtl, AutogenRowTariffRegionLtl } from "./autogen/AutogenModelTariffRegionLtl";

export class ModelTariffRegionLtl extends AutogenModelTariffRegionLtl<RowTariffRegionLtl> {
	constructor() {
		super(RowTariffRegionLtl);
	}
}

export class RowTariffRegionLtl extends AutogenRowTariffRegionLtl {
}